import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { QuoteIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const testimonials = [{
  name: 'Sarah J.',
  text: 'Renova8 & Build transformed our home into a modern masterpiece. Highly professional and detail-oriented!',
  rating: 5
}, {
  name: 'Michael T.',
  text: 'Exceptional quality and luxury finishes. Our kitchen and bathroom look stunning.',
  rating: 5
}, {
  name: 'Emma L.',
  text: 'From start to finish, the team was incredible. They exceeded all our expectations!',
  rating: 5
}];
export function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2
  });
  const nextTestimonial = () => {
    setCurrentIndex(prev => (prev + 1) % testimonials.length);
  };
  const prevTestimonial = () => {
    setCurrentIndex(prev => (prev - 1 + testimonials.length) % testimonials.length);
  };
  return <section id="testimonials" className="py-12 sm:py-16 md:py-20 bg-[#0f0f0f]" ref={ref} data-id="element-238">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-239">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-10 sm:mb-12 md:mb-16" data-id="element-240">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-3 sm:mb-4" data-id="element-241">
            What Our <span className="text-[#d4af37]" data-id="element-242">Clients Say</span>
          </h2>
        </motion.div>
        <div className="relative" data-id="element-243">
          <AnimatePresence mode="wait" data-id="element-244">
            <motion.div key={currentIndex} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -20
          }} transition={{
            duration: 0.5
          }} className="bg-[#1c1c1c] rounded-lg p-6 sm:p-8 md:p-12 relative" data-id="element-245">
              <QuoteIcon className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 text-[#d4af37] mb-4 sm:mb-6" data-id="element-246" />
              <p className="text-gray-300 text-base sm:text-lg md:text-xl leading-relaxed mb-4 sm:mb-6" data-id="element-247">
                {testimonials[currentIndex].text}
              </p>
              <div className="flex items-center gap-1 sm:gap-2 mb-3 sm:mb-4" data-id="element-248">
                {[...Array(testimonials[currentIndex].rating)].map((_, i) => <span key={i} className="text-[#d4af37] text-xl sm:text-2xl" data-id="element-249">
                    ★
                  </span>)}
              </div>
              <p className="text-white font-semibold text-base sm:text-lg" data-id="element-250">
                {testimonials[currentIndex].name}
              </p>
            </motion.div>
          </AnimatePresence>
          {/* Navigation */}
          <div className="flex justify-center gap-3 sm:gap-4 mt-6 sm:mt-8" data-id="element-251">
            <button onClick={prevTestimonial} className="w-10 h-10 sm:w-12 sm:h-12 bg-[#d4af37] rounded-full flex items-center justify-center hover:bg-[#4b4bff] transition-colors duration-300 active:scale-90 touch-manipulation" data-id="element-252">
              <ChevronLeftIcon className="w-5 h-5 sm:w-6 sm:h-6 text-[#1c1c1c]" data-id="element-253" />
            </button>
            <button onClick={nextTestimonial} className="w-10 h-10 sm:w-12 sm:h-12 bg-[#d4af37] rounded-full flex items-center justify-center hover:bg-[#4b4bff] transition-colors duration-300 active:scale-90 touch-manipulation" data-id="element-254">
              <ChevronRightIcon className="w-5 h-5 sm:w-6 sm:h-6 text-[#1c1c1c]" data-id="element-255" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}